<template>
  <div>
    <a-skeleton active :loading="loadTag" />
    <template v-for="(item, index) in orderDetail" :key="index">
      <!-- 车次信息 -->
      <div v-show="!loadTag">
        <div class="trainInfo">
          <div class="title">
            车次信息<span style="color: red">{{
              orderDetail[0].orderBoList.length
                ? ""
                : orderDetail[0].orderStateValue == "全部改签" || orderDetail[0].orderStateValue == "全部退票"
                ? ""
                : "（ " + orderDetail[0].orderStateValue + "  失败原因："+ orderDetail[0].remark +  " ）"
            }}</span>
          </div>
          <a-row class="main">
            <!-- '（ ' +  orderDetail[0].orderStateValue  + ' ）' -->
            <a-col :span="13">
              <div class="top">{{ item.fromTimeFormat }} 出发</div>
              <a-row class="box">
                <a-col :span="8">
                  <div class="time">{{ item.fromTime }}</div>
                  <div class="city">{{ item.fromStation }}</div>
                </a-col>
                <a-col :span="8" class="maiddle">
                  <div class="runTime">
                    {{ item.takeTimeFormat }}
                    <a-tag color="#3999fb" @click="stopShowAction(item)">
                      经停
                    </a-tag>
                    <!-- <img src="@assets/img/idcard.png" /> -->
                  </div>
                  <img src="@assets/img/cardline.png" />
                  <div class="trainNo">{{ item.trainNo }}</div>
                  <transition name="fade-transform" mode="out-in">
                    <div class="box" v-show="stateListShow">
                      <div class="box_title">
                        经停站<CloseCircleOutlined
                          :style="{
                            color: '#6D7278'
                          }"
                          @click="close"
                        />
                      </div>
                      <div class="box-content">
                        <a-row class="row_content row_title">
                          <a-col span="2"></a-col>
                          <a-col span="5">车站名</a-col>
                          <a-col span="6">到达时间</a-col>
                          <a-col span="6">发车时间</a-col>
                          <a-col span="5">停留时间</a-col>
                        </a-row>
                        <div class="row_list_content">
                          <a-skeleton active v-if="!stopStateList.length" />
                          <a-row class="row_content row_list" v-for="(item, index) in stopStateList" :key="index">
                            <a-col span="2">{{ item.serialNumber }}</a-col>
                            <a-col span="5">{{ item.station }}</a-col>
                            <a-col span="6">{{ item.arrivalTime }}</a-col>
                            <a-col span="6">{{ item.departureTime }}</a-col>
                            <a-col span="5">{{ item.stayTimeSpan }}</a-col>
                          </a-row>
                        </div>
                      </div>
                    </div>
                  </transition>
                </a-col>
                <a-col :span="8" class="right">
                  <div class="time">{{ item.toTime }}</div>
                  <div class="city">{{ item.toStation }}</div>
                </a-col>
              </a-row>
              <div class="bottom">
                <span v-if="item.ticketCheck">{{ "检票口：" + item.ticketCheck }}</span>
              </div>
            </a-col>
            <a-col :span="11" v-if="!showLoadingOut(item)">
              <a-row class="item" v-for="(value, key) in finishing(item)" :key="key">
                <a-col :span="12">火车票（ {{ typeName[key] }} ）</a-col>
                <a-col :span="12" class="price">¥{{ value.ticketLastPrice * value.num }}</a-col>
              </a-row>
              <a-row class="item" v-if="item.insuranceAmount">
                <a-col :span="12">保险服务</a-col>
                <a-col :span="12" class="price">¥{{ item.insuranceAmount }}</a-col>
              </a-row>
              <a-row class="item" v-if="item.serviceAmount">
                <a-col :span="12">服务费</a-col>
                <a-col :span="12" class="price">¥{{ item.serviceAmount }}</a-col>
              </a-row>
              <a-row class="item">
                <a-col :span="12" class="totle_price">总额</a-col>
                <a-col :span="12" class="price">¥{{ item.totalAmount }}</a-col>
              </a-row>
            </a-col>
            <a-col :span="11" v-else class="loading_cont">
              <a-button type="primary" class="loading_btn" loading>
                {{ showLoadingOut(item) }}
              </a-button>
            </a-col>
          </a-row>
        </div>
        <!-- 乘客信息 -->
        <div class="passengerInfo">
          <a-row class="title">
            <a-col :span="12">
              <div class="title-left">乘客信息</div>
            </a-col>
            <a-col :span="12" class="title-right" v-if="item.orderState == 50">
              <span
                class="change"
                @click="changeOutActionType(1, getEndorse(item.passengersList, item.isCanReturnOrChange))"
                :class="{
                  choosed: item.cardActionType == 1,
                  noendorse: getEndorse(item.passengersList, item.isCanReturnOrChange)
                }"
                >改签</span
              >
              <span class="line">|</span>
              <span
                class="refund"
                @click="changeOutActionType(2, getRefund(item.passengersList, item.isCanReturnOrChange))"
                :class="{
                  choosed: item.cardActionType == 2,
                  noendorse: getRefund(item.passengersList, item.isCanReturnOrChange)
                }"
                >退票</span
              >
            </a-col>
          </a-row>
          <a-row
            class="main"
            v-for="(data, dataIndex) in item.passengersList"
            :key="dataIndex"
            @click="changeOutRadio(dataIndex, data.isCanReturn, data.isCanChange)"
            :class="{
              grayClass: data.state >= 30 && data.state != 50 && data.state != 60
            }"
          >
            <a-col :span="4" class="name">
              <span v-if="item.cardActionType">
                <a-checkbox
                  v-show="item.cardActionType == 1"
                  :disabled="!data.isCanChange"
                  v-model:checked="data.checkbox"
                  @change="passengerChange"
                >
                </a-checkbox>

                <df-radio
                  :disabled="!data.isCanReturn"
                  v-show="item.cardActionType == 2"
                  :checked="data.radio"
                ></df-radio>
              </span>

              {{ data.passengerName }}
            </a-col>
            <a-col :span="4" class="type">{{ data.passengerTypeValue }}</a-col>
            <a-col :span="7">
              {{ data.seatName }}
              {{ data.lastCoach }}
              {{ data.lastSeat }}
            </a-col>
            <a-col :span="4" class="regular">
              <span v-if="data.state == 10 || data.state == 20 || data.state == 30 || data.state == 40">{{
                data.stateValue
              }}</span>
              <span v-else>正常</span>
            </a-col>
            <a-col :span="5" class="price regular">¥{{ data.ticketLastPrice }}</a-col>
            <div style="color: #fd5739" v-if="data.refundError || data.state == 50">
              {{ data.refundError }}
            </div>
          </a-row>
        </div>
        <!-- 保险 -->
        <div
          class="passengerInfo insurance"
          v-if="item.orderPassengersInsurance && item.orderPassengersInsurance.length > 0"
        >
          <a-row class="title">
            <a-col :span="24">
              <div class="title-left">保险信息</div>
            </a-col>
          </a-row>
          <a-row
            class="main"
            v-for="(data, dataIndex) in item.orderPassengersInsurance"
            :key="dataIndex"
            :class="{
              grayClass:
                data.returnState >= 30 || data.insuranceState >= 31 || item.orderState == 60 || item.orderState == 90
            }"
          >
            <a-col :span="4" class="name">
              {{ data.orderPassengerName }}
            </a-col>
            <a-col :span="4" class="name">{{ data.insuranceName }}</a-col>
            <a-col :span="10">
              保单：
              {{ data.insureNo }}
            </a-col>
            <a-col :span="3" class="price" v-if="data.insuranceState !== 31" style="color: #ff0000">
              <span>{{ data.stateValue }}</span>
            </a-col>
            <a-col :span="3" class="price" v-else style="color: #f7b500">
              <WarningOutlined style="margin-right: 2px" />
              <span>{{ data.stateValue }}</span>
            </a-col>
            <a-col :span="3" class="price regular"> ¥{{ data.insuranceAmount }} </a-col>
          </a-row>
        </div>
        <!-- btn -->
        <div class="bottomInfo" v-show="item.cardActionType">
          <div class="handleBtn" @click="toRefund">立即{{ item.cardActionType == 1 ? "改签" : "退票" }}</div>
        </div>
      </div>

      <div
        class="endorse_cont"
        v-for="(sun, sunIndex) in item.orderBoList"
        :key="sunIndex"
        v-show="sun.orderState == 50 && !loadTag"
      >
        <div class="trainInfo">
          <div class="title">车次信息<span style="color: red">（ 改签 ）</span></div>
          <a-row class="main">
            <a-col :span="13">
              <div class="top">{{ sun.fromTimeFormat }} 出发</div>
              <a-row class="box">
                <a-col :span="8">
                  <div class="time">{{ sun.fromTime }}</div>
                  <div class="city">{{ sun.fromStation }}</div>
                </a-col>
                <a-col :span="8" class="maiddle">
                  <div class="runTime">
                    {{ sun.takeTimeFormat }}
                    <img src="@assets/img/idcard.png" />
                  </div>
                  <img src="@assets/img/cardline.png" />
                  <div class="trainNo">{{ sun.trainNo }}</div>
                </a-col>
                <a-col :span="8" class="right">
                  <div class="time">{{ sun.toTime }}</div>
                  <div class="city">{{ sun.toStation }}</div>
                </a-col>
              </a-row>
              <div class="bottom">
                <span v-if="sun.ticketCheck">{{ "检票口：" + sun.ticketCheck }}</span>
              </div>
            </a-col>
            <a-col :span="11" v-if="!showLoadingOut(sun)">
              <a-row class="item" v-for="(value, key) in finishing(sun)" :key="key">
                <a-col :span="12">火车票（ {{ typeName[key] }} ）</a-col>
                <a-col :span="12" class="price">¥{{ value.ticketLastPrice * value.num }}</a-col>
              </a-row>
              <a-row class="item" v-if="sun.insuranceAmount">
                <a-col :span="12">保险服务</a-col>
                <a-col :span="12" class="price">¥{{ sun.insuranceAmount }}</a-col>
              </a-row>
              <a-row class="item" v-if="sun.serviceAmount">
                <a-col :span="12">服务费</a-col>
                <a-col :span="12" class="price">¥{{ sun.serviceAmount }}</a-col>
              </a-row>
              <a-row class="item">
                <a-col :span="12" class="totle_price">总额</a-col>
                <a-col :span="12" class="price">¥{{ sun.payAmount }}</a-col>
              </a-row>
            </a-col>
            <a-col :span="11" v-else class="loading_cont">
              <a-button type="primary" class="loading_btn" loading>
                {{ showLoadingOut(sun) }}
              </a-button>
            </a-col>
          </a-row>
        </div>
        <!-- 乘客信息 -->
        <div class="passengerInfo">
          <a-row class="title">
            <a-col :span="12">
              <div class="title-left">乘客信息</div>
            </a-col>
            <a-col :span="12" class="title-right" v-if="sun.orderState == 50">
              <span
                class="change"
                @click="changeActionType(sunIndex, 1, true)"
                :class="{
                  choosed: sun.cardActionType == 1,
                  noendorse: getEndorse(sun.passengersList, sun.isCanReturnOrChange)
                }"
                >改签</span
              >
              <span class="line">|</span>
              <span
                class="refund"
                @click="changeActionType(sunIndex, 2, getRefund(sun.passengersList, sun.isCanReturnOrChange))"
                :class="{
                  choosed: sun.cardActionType == 2,
                  noendorse: getRefund(sun.passengersList, sun.isCanReturnOrChange)
                }"
                >退票</span
              >
            </a-col>
          </a-row>
          <a-row
            class="main"
            v-for="(grandson, grandsonIndex) in sun.passengersList"
            :key="grandsonIndex"
            @click="changeRadio(sunIndex, grandsonIndex, grandson.isCanReturn, grandson.isCanChange)"
            :class="{
              grayClass: grandson.state >= 30 && grandson.state != 50 && grandson.state != 60
            }"
          >
            <a-col :span="4" class="name">
              <span v-if="sun.cardActionType">
                <a-checkbox
                  v-show="sun.cardActionType == 1"
                  :disabled="!grandson.isCanChange"
                  v-model:checked="grandson.checkbox"
                  @change="passengerChange"
                >
                </a-checkbox>

                <df-radio
                  :disabled="!grandson.isCanReturn"
                  v-show="sun.cardActionType == 2"
                  :checked="grandson.radio"
                ></df-radio>
              </span>

              {{ grandson.passengerName }}
            </a-col>
            <a-col :span="4" class="type">{{ grandson.passengerTypeValue }}</a-col>
            <a-col :span="7">
              {{ grandson.seatName }}
              {{ grandson.lastCoach }}
              {{ grandson.lastSeat }}
            </a-col>
            <a-col :span="4" class="regular">
              <span
                v-if="grandson.state == 10 || grandson.state == 20 || grandson.state == 30 || grandson.state == 40"
                >{{ grandson.stateValue }}</span
              >
              <span v-else>正常</span>
            </a-col>
            <a-col :span="5" class="price regular">¥{{ grandson.ticketLastPrice }}</a-col>
            <div style="color: #fd5739" v-if="grandson.refundError || grandson.state == 50">
              {{ grandson.refundError }}
            </div>
          </a-row>
        </div>
        <!-- 保险 -->
        <div
          class="passengerInfo insurance"
          v-if="sun.orderPassengersInsurance && sun.orderPassengersInsurance.length > 0"
        >
          <a-row class="title">
            <a-col :span="24">
              <div class="title-left">保险信息</div>
            </a-col>
          </a-row>
          <a-row
            class="main"
            v-for="(data, dataIndex) in sun.orderPassengersInsurance"
            :key="dataIndex"
            :class="{
              grayClass:
                data.returnState >= 30 || data.insuranceState >= 31 || sun.orderState == 60 || sun.orderState == 90
            }"
          >
            <a-col :span="4" class="name">
              {{ data.orderPassengerName }}
            </a-col>
            <a-col :span="4" class="name">{{ data.insuranceName }}</a-col>
            <a-col :span="10">
              保单：
              {{ data.insureNo }}
            </a-col>
            <a-col :span="3" class="price" v-if="data.insuranceState !== 31" style="color: #ff0000">
              <span>{{ data.stateValue }}</span>
            </a-col>
            <a-col :span="3" class="price" v-else style="color: #f7b500">
              <WarningOutlined style="margin-right: 2px" />
              <span>{{ data.stateValue }}</span>
            </a-col>
            <a-col :span="3" class="price regular"> ¥{{ data.insuranceAmount }} </a-col>
          </a-row>
        </div>
        <!-- btn -->
        <div class="bottomInfo" v-show="sun.cardActionType">
          <div class="handleBtn" @click="toRefund">立即{{ sun.cardActionType == 1 ? "改签" : "退票" }}</div>
        </div>
      </div>
    </template>

    <div class="tips_cont"></div>

    <div class="confirm_order" v-show="orderDetail[0].orderState == 30">
      <a-button type="primary" class="submitBtn" @click="confirmOrder">
        支付
      </a-button>
      <a-button type="primary" class="concelBtn" @click="cancelOrder">
        取消
      </a-button>
    </div>
  </div>
</template>
<script>
import { ref, watch, nextTick } from "vue";
import commonApi from "@axios/common";
import { useRouter, useRoute } from "vue-router";
import {
  MailOutlined,
  AppstoreOutlined,
  SettingOutlined,
  WarningOutlined,
  CloseCircleOutlined
} from "@ant-design/icons-vue";
import homeApi from "@axios/home";
import { Modal, message } from "ant-design-vue";
import { throws } from "assert";
let timer;
export default {
  name: "orderDetail",
  components: {
    MailOutlined,
    AppstoreOutlined,
    SettingOutlined,
    WarningOutlined,
    CloseCircleOutlined
  },
  setup() {
    let router = useRouter();
    const route = useRoute();

    let orderCode = route.query.orderCode;

    let orderDetail = ref([
      {
        orderBoList: [],
        passengersList: []
      }
    ]);

    let loadTag = ref(true);
    let loadcont = ref(0);
    const getOrderDetail = () => {
      homeApi.getOrderDetail(orderCode).then((res) => {
        // res.orderState = 30;
        // res.orderBoList[0].passengersList[0].state = 10
        // res.orderBoList[0].passengersList[0].stateValue = '退票中'
        loadcont.value++;
        if (loadcont.value == 1) {
          loadTag.value = false;
        }

        res.cardActionType = 0;
        res.orderBoList.forEach((element) => {
          element.cardActionType = 0;
        });

        nextTick(() => {
          orderDetail.value = [res];
        });
      });
    };

    getOrderDetail();

    // 乘客信息
    let passengerChecked = ref(false);
    const passengerChange = (e) => {
      console.log(e.target.checked);
    };

    const changeOutActionType = (type, tag) => {
      if (tag == true) return;

      if (orderDetail.value[0].cardActionType == type) {
        orderDetail.value[0].cardActionType = 0;
      } else {
        allActionClose();
        orderDetail.value[0].cardActionType = type;
      }
    };

    const changeOutRadio = (dataIndex, rtag, ctag) => {
      if (orderDetail.value[0].cardActionType == 1) {
        //改签多选
        if (!ctag) return; //以后放开 数据问题暂留

        orderDetail.value[0].passengersList[dataIndex].checkbox = !orderDetail.value[0].passengersList[dataIndex]
          .checkbox;
      } else {
        //退票单选
        if (!rtag) return; //以后放开 数据问题暂留
        if (orderDetail.value[0].passengersList[dataIndex].radio) {
          orderDetail.value[0].passengersList[dataIndex].radio = false;
        } else {
          orderDetail.value[0].passengersList.forEach((element) => {
            element.radio = false;
          });
          orderDetail.value[0].passengersList[dataIndex].radio = true;
        }
      }
    };

    //所有退票改签关闭
    const allActionClose = () => {
      orderDetail.value[0].cardActionType = 0;
      orderDetail.value[0].orderBoList.forEach((element) => {
        element.cardActionType = 0;
      });
    };

    const changeActionType = (sunindex, type, tag) => {
      if (tag == true) return;
      if (orderDetail.value[0].orderBoList[sunindex].cardActionType == type) {
        orderDetail.value[0].orderBoList[sunindex].cardActionType = 0;
      } else {
        allActionClose();
        orderDetail.value[0].orderBoList[sunindex].cardActionType = type;
      }
    };

    const changeRadio = (index, gindex, rtag, ctag) => {
      if (orderDetail.value[0].orderBoList[index].cardActionType == 1) {
        if (!ctag) return; //以后放开 数据问题暂留
        orderDetail.value[0].orderBoList[index].passengersList[gindex].checkbox = !orderDetail.value[0].orderBoList[
          index
        ].passengersList[gindex].checkbox;
      } else {
        if (!rtag) return; //以后放开 数据问题暂留
        if (orderDetail.value[0].orderBoList[index].passengersList[gindex].radio) {
          orderDetail.value[0].orderBoList[index].passengersList[gindex].radio = false;
        } else {
          orderDetail.value[0].orderBoList[index].passengersList.forEach((element) => {
            element.radio = false;
          });
          orderDetail.value[0].orderBoList[index].passengersList[gindex].radio = true;
        }
      }
    };

    const showLoadingOut = (item) => {
      if (item.orderState < 50 && item.orderState != 30) {
        //刷无疑
        setReload();
        return item.orderStateValue;
      } else {
        //如果不是主订单状态 查乘客状态有没有
        for (var i = 0; i < item.passengersList.length; i++) {
          if (item.passengersList[i].state == 10 || item.passengersList[i].state == 20) {
            console.log(item.passengersList[i].stateValue);
            setReload();
            return item.passengersList[i].stateValue;
          }
        }
      }

      return "";
    };

    const setReload = () => {
      if (timer) clearInterval(timer);
      timer = setTimeout(() => {
        getOrderDetail();
      }, 5000);
    };

    const finishing = (item) => {
      let obj = {};
      item.passengersList.forEach((element) => {
        if (element.passengerType === 1) {
          if (obj.adultList) {
            obj.adultList.num++;
          } else {
            obj.adultList = {
              num: 1,
              ticketLastPrice: element.ticketLastPrice
            };
          }
        } else if (element.passengerType === 2) {
          if (obj.childList) {
            obj.childList.num++;
          } else {
            obj.childList = {
              num: 1,
              ticketLastPrice: element.ticketLastPrice
            };
          }
        } else if (element.passengerType === 3) {
          if (obj.studentList) {
            obj.studentList.num++;
          } else {
            obj.studentList = {
              num: 1,
              ticketLastPrice: element.ticketLastPrice
            };
          }
        } else if (element.passengerType === 4) {
          if (obj.disabilityList) {
            obj.disabilityList.num++;
          } else {
            obj.disabilityList = {
              num: 1,
              ticketLastPrice: element.ticketLastPrice
            };
          }
        }
      });
      return obj;
    };

    let typeName = {
      adultList: "成人票",
      childList: "儿童票",
      studentList: "学生票",
      disabilityList: "残军票"
    };

    //验证是否可以改签
    const getEndorse = (list, ctag) => {
      let tag = false;

      if (!ctag) return !tag;
      list.forEach((ele) => {
        if (ele.isCanChange) {
          tag = true;
        }
      });
      return !tag;
    };
    //验证是否可退票
    const getRefund = (list, ctag) => {
      let tag = false;
      if (!ctag) return !tag;
      list.forEach((ele) => {
        if (ele.isCanReturn) {
          tag = true;
        }
      });
      return !tag;
    };

    const cancelOrder = () => {
      let params = {
        orderCode: orderDetail.value[0].orderCode
      };

      Modal.confirm({
        content: "请再次确认是否取消？",
        onOk() {
          homeApi.cancelOrder(params).then((res) => {
            getOrderDetail();
          });
        },
        cancelText: "取消",
        okText: "确定",
        onCancel() {
          Modal.destroyAll();
        }
      });
    };

    const confirmOrder = () => {
      // let params = {
      //   orderCode : orderDetail.value[0].orderCode
      // }

      // homeApi.confirmOrder(params).then((res)=>{
      //   getOrderDetail()
      // })

      let params = {
        orderCode: orderDetail.value[0].orderCode,
        appPlatform: 10,
        returnUrl: window.location.href
      };

      homeApi.goPay(params).then((res) => {
        window.location.href = res.cashierUrl + "?advanceOrderNo=" + res.advanceOrderNo; //为了支付完回跳。。暂时只有火车票业务其实用不上 type=train
      });
    };

    const toRefund = () => {
      console.log(orderDetail.value[0].cardActionType);
      if (orderDetail.value[0].cardActionType == 2) {
        //主票退票
        let passengerId;
        orderDetail.value[0].passengersList.forEach((element) => {
          if (element.radio) {
            passengerId = element.id;
          }
        });
        if (!passengerId) {
          message.error("请选择要退的车票");
          return;
        }
        router.push({
          name: "orderRefund",
          query: {
            orderCode: orderDetail.value[0].orderCode,
            passenger: passengerId
          }
        });
      } else if (orderDetail.value[0].cardActionType == 1) {
        //主票改签
        let json = {
          orderCode: orderDetail.value[0].orderCode,
          fromStation: orderDetail.value[0].fromStation,
          toStation: orderDetail.value[0].toStation,
          trainDate: orderDetail.value[0].trainDate,
          passengersList: []
        };

        orderDetail.value[0].passengersList.forEach((ele) => {
          if (ele.checkbox) {
            let oobj = {};
            oobj = ele;
            oobj.children = [];

            orderDetail.value[0].passengersList.forEach((element) => {
              if (element.passengerType == 2) {
                if (ele.passengerId == element.passengerId && element.state != 30 && element.state != 20) {
                  oobj.children.push(element);
                }
              }
            });
            json.passengersList.push(oobj);
          }
        });

        if (!json.passengersList.length) {
          message.error("请选择要改签的乘客");
          return;
        }

        localStorage.setItem("endorse", JSON.stringify(json));
        //改签跳转需要更改 待定
        router.push({
          path: "/",
          query: {
            endorse: 1
          }
        });
      } else {
        try {
          orderDetail.value[0].orderBoList.forEach((ele) => {
            if (ele.cardActionType == 2) {
              //改签单退票
              let passengerId;
              ele.passengersList.forEach((element) => {
                if (element.radio) {
                  passengerId = element.id;
                  router.push({
                    name: "orderRefund",
                    query: {
                      orderCode: ele.orderCode,
                      passenger: passengerId
                    }
                  });
                  throw new Exception("something wrong first");
                }
              });
            }
          });
        } catch (err) {
          return;
        }

        message.error("请选择要退票的订单");
        return;
      }
    };

    // 经停
    let stopStateList = ref([]);
    let stateListShow = ref(false);

    const stopShowAction = (item) => {
      stateListShow.value = true;
      console.log(item);
      let params = {
        trainNo: item.trainNo,
        fromStation: item.fromStation,
        toStation: item.toStation,
        trainDate: item.trainDate
        // trainCode: item.trainLongNo
      };
      homeApi.trainStopStation(params).then((res) => {
        stopStateList.value = res.stations;
      });
    };
    const close = () => {
      stateListShow.value = false;
    };

    return {
      loadcont,
      loadTag,
      toRefund,
      cancelOrder,
      confirmOrder,
      typeName,
      finishing,
      showLoadingOut,
      changeRadio,
      changeActionType,
      changeOutRadio,
      changeOutActionType,
      getRefund,
      getEndorse,
      orderDetail,
      passengerChecked,
      passengerChange,
      stopStateList,
      stopShowAction,
      stateListShow,
      close
    };
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.totle_price {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #000000;
}
.regular {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.confirm_order {
  margin-top: 100px;
  display: flex;
  justify-content: flex-end;
  .submitBtn,
  .concelBtn {
    width: 167px;
    height: 40px;
  }
  .submitBtn {
    background: #ffab00;
    border-color: #ffab00;
    margin-right: 17px;
  }
  .concelBtn {
    background: #f8f8f8;
    border-color: #f8f8f8;
    color: #000000;
  }
}

.loading_cont {
  ::v-deep(.ant-btn.ant-btn-loading)::before {
    display: none !important;
  }
}

.loading_btn {
  background: #ffab00;
  border-color: #ffab00;
  width: 125px;
  height: 35px;
  cursor: wait;
}
.loading_cont {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.endorse_cont {
  margin-top: 100px;
}
.grayClass {
  color: #dedfe3 !important;
  .price,
  .type {
    color: #dedfe3 !important;
  }
}
.name {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  font-family: PingFangSC-Medium, PingFang SC;
  span {
    margin-right: 10px;
  }
}
.orderDetail {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 15px;
  box-sizing: border-box;
  font-size: 14px;
}
.topTitle {
  line-height: 20px;
  margin-bottom: 20px;
  span {
    margin: 0 2px;
  }
}

.trainInfo {
  border: 0.5px solid #cdcccd;
  .title {
    height: 68px;
    line-height: 68px;
    font-size: 16px;
    padding-left: 26px;
    border-bottom: 0.5px solid #cdcccd;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
  }
  .main {
    padding: 15px 33px;
    display: flex;
    justify-content: flex-start;
    // height: 180px;

    .ant-col-13 {
      border-right: 0.5px solid #cdcccd;
      .top {
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 9px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
      }
      .box {
        padding-right: 40px;
        .time {
          line-height: 28px;
          margin-bottom: 8px;

          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
        }
        .city {
          line-height: 22px;

          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
        }
        .maiddle {
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          position: relative;
          .box {
            width: 430px;
            background: #fff;
            border: 0.5px solid #cdcccd;
            padding: 26px 13px;
            position: absolute;
            z-index: 10;
            left: 50%;
            top: 70px;
            transform: translateX(-50%);
          }
          & > img {
            width: 95px;
          }
          .runTime {
            font-size: 14px;
            line-height: 20px;
            color: #000000;

            font-family: PingFangSC-Light, PingFang SC;
            img {
              width: 17px;
              position: relative;
              top: -1px;
            }
          }
          .trainNo {
            line-height: 28px;
            font-size: 20px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #fd5839;
          }
        }
        .right {
          text-align: right;
        }
      }
      .bottom {
        padding-right: 40px;
        text-align: right;
        margin-top: 18px;
        span {
          font-size: 12px;
          color: #3999fb;
          border: 0.5px solid #3999fb;
          border-radius: 10px;
          padding: 1px 8px;
        }
      }
    }
    .ant-col-11 {
      padding: 31px 47px;
      .item {
        line-height: 26px;
        // margin-bottom: 8px;
        .price {
          text-align: right;
          font-size: 16px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: #000000;
        }
      }
    }
  }
}
.passengerInfo {
  background: rgba(248, 248, 248, 1);
  padding: 20px 10px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  .title {
    padding-right: 47px;
    .title-left {
      font-size: 16px;
      line-height: 22px;
      padding: 0 21px;
      margin-bottom: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
    }
    .title-right {
      text-align: right;
      .change {
        font-size: 14px;
        cursor: pointer;
      }
      .line {
        margin: 0 20px;
        color: rgba(0, 0, 0, 0.35);
      }
      .choosed {
        color: #ffab00;
        text-decoration: underline;
      }
      .refund {
        cursor: pointer;
      }
    }
  }
  .main {
    padding: 5px 47px 5px 21px;
    // height: 40px;
    line-height: 40px;
    font-size: 16px;
    border-bottom: 0.5px dashed rgba(189, 192, 200, 0.5);
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #000000;
    &:last-of-type {
      border-bottom: none;
    }
    .type {
      font-size: 14px;
      color: #6d7278;
    }
    .price {
      text-align: right;
      color: #ff0000;

      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
  }
}
.insurance {
  background: #ffffff;
  // padding: 15px 10px;
  // .title {
  //   .title-left {
  //     font-size: 14px;
  //     line-height: 20px;
  //     margin-bottom: 0;
  //   }
  // }
  // .main {
  //   line-height: 30px;
  //   font-size: 14px;
  // }
}
.noendorse {
  color: #dedfe3 !important;
}
.bottomInfo {
  text-align: right;
  margin: 20px 0 60px 0;
  .handleBtn {
    display: inline-block;
    padding: 9px 50px;
    background: #ffab00;
    font-size: 16px;
    color: #ffffff;
    border-radius: 4px;
    cursor: pointer;
  }
}
// 经停
.box_title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  display: flex;
  justify-content: space-between;
  border-bottom: 3px solid #cdcccd;
  padding-bottom: 6px;
}
// .title {
//   color: #fff;
//   font-size: 20px;
// }
.box-content {
  // padding:26px 20px;
  margin-top: 11px;
}
.row_list_content {
  max-height: 400px;
  overflow-y: auto;
}
.row_content {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  text-align: center;
}
.row_list {
  margin-bottom: 8px;
}
.row_title {
  margin-bottom: 11px;
}
</style>
